module.exports = __webpack_public_path__ + "static/media/child.1aa4b8f0.svg";